/**
 * productMockups — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const productMockupsPack: ToilePack = {
    slug: 'product-mockups',
    category: 'mockup',
    name: 'Product mockups',
    tagline: tagline('mockups', 'products', 'settings'),
    chips: chips('products', 'settings'),
    ratio: SQUARE,
    readings: [
        {key: 'candle', label: 'Candle', subject: 'a soy candle in a frosted glass jar, wooden lid'},
        {key: 'coffee', label: 'Coffee pouch', subject: 'a stand-up coffee pouch with a valve, kraft paper'},
        {key: 'skincare', label: 'Serum bottle', subject: 'a frosted glass dropper bottle of face serum'},
    ],
    styles: [
        {key: 'studio', label: 'Studio', style: 'seamless pale backdrop, soft studio light', palette: 'unbranded, plain surface', framing: 'front view'},
        {key: 'scene', label: 'Lifestyle scene', style: 'styled lifestyle scene, morning window light', palette: 'unbranded, plain surface', framing: 'marble counter, eucalyptus'},
        {key: 'flatlay', label: 'Flat-lay', style: 'flat-lay from above, matching props', palette: 'unbranded, plain surface', framing: 'colored paper background'},
    ],
    directions: ['a soap bar instead', 'against a dark background', 'with a second size'],
}
